export const UNITY_SOURCE_STORAGE_KEY = 'vm_unity_source';

export const UNITY_BILLING_RESTRICTED_PLATFORMS = new Set([
  'ios',
  'android',
  'macos',
]);

const normalizeValue = (value) => (value || '').toString().trim().toLowerCase();

export const parseUnitySourceFromSearch = (search = '') => {
  if (!search) {
    return null;
  }

  const normalizedSearch = search.startsWith('?') ? search : `?${search}`;
  const params = new URLSearchParams(normalizedSearch);
  const source = normalizeValue(params.get('source'));
  const platform = normalizeValue(params.get('platform'));

  if (source !== 'unity' || !platform) {
    return null;
  }

  return { source, platform };
};

export const readStoredUnitySource = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const stored = window.sessionStorage.getItem(UNITY_SOURCE_STORAGE_KEY);
    if (!stored) {
      return null;
    }

    const parsed = JSON.parse(stored);
    const source = normalizeValue(parsed?.source);
    const platform = normalizeValue(parsed?.platform);
    return source && platform ? { source, platform } : null;
  } catch {
    return null;
  }
};

export const storeUnitySource = (source) => {
  if (typeof window === 'undefined' || !source?.source || !source?.platform) {
    return;
  }

  try {
    window.sessionStorage.setItem(UNITY_SOURCE_STORAGE_KEY, JSON.stringify({
      source: normalizeValue(source.source),
      platform: normalizeValue(source.platform),
    }));
  } catch {
    // Ignore storage errors; billing visibility will fall back to the current URL.
  }
};

export const isUnityBillingRestricted = (source) => (
  normalizeValue(source?.source) === 'unity'
  && UNITY_BILLING_RESTRICTED_PLATFORMS.has(normalizeValue(source?.platform))
);
